import { useEffect } from 'react'
import { useAppDispatch } from 'state'
import { useIsAuthenticated } from 'state/profile/hooks'
import { fetchAffiliateInfo, resetState } from '.'

export const useReferrals = () => {
  const dispatch = useAppDispatch()
  const isAuthenticated = useIsAuthenticated()

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(fetchAffiliateInfo())
    } else {
      dispatch(resetState())
    }
  }, [isAuthenticated, dispatch])
}
